import React, { useState } from 'react';
import './BusinessModelSecond.css';
import image2 from '../../assets/Bsp4.webp';
import image3 from '../../assets/1.webp';
import image4 from '../../assets/2.webp';
import image5 from '../../assets/loop.webp';
import Title from '../../components/Title/Title';

interface ModalProps {
  src: string;
  alt: string;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ src, alt, onClose }) => (
  <div className="business-model-second-modal" onClick={onClose}>
    <img src={src} alt={alt} className="business-model-second-modal-image" onClick={(e) => e.stopPropagation()} />
  </div>
);

const BusinessModelSecond: React.FC = () => {
  const [modalImage, setModalImage] = useState<string | null>(null);

  const openModal = (src: string) => setModalImage(src);
  const closeModal = () => setModalImage(null);

  const steps = [
    {
      title: "Styropor Volumenreduzierung",
      description: "Zunächst sorgen wir dafür, dass aus viel Styropor und EPS Volumen im ersten Schritt viel weniger wird. Durch den Einsatz spezieller Maschinen wird das sperrige Material zerkleinert und verdichtet – der Beginn der professionellen Styropor Entsorgung.",
      image: image2,
      width: 400,
      height: 200,
    },
    {
      title: "Polystyrol Komprimierung",
      description: "Anschließend wird das deutlich reduzierte Styropor-Volumen in kompakte Blöcke gepresst und auf Paletten gestapelt. Diese Verdichtung ermöglicht einen kosteneffizienten und umweltschonenden Transport zur Verwertungsanlage – effizientes EPS Recycling.",
      image: image3,
      width: 400,
      height: 200,
    },
    {
      title: "Transport zur Recycling-Anlage",
      description: "Das jetzt im Volumen um ca. 80 Prozent reduzierte Styropor ist nun transportfertig und wird in die Recycling-Anlage verbracht. Weniger Volumen bedeutet weniger Transportfahrten und geringere Logistikkosten – so senken wir Ihre Entsorgungskosten nachhaltig.",
      image: image4,
      width: 400,
      height: 200,
    },
    {
      title: "Neue Verwendung durch Styropor Recycling",
      description: "Anschließend kann das recycelte Polystyrol für diverse neue Produkte genutzt werden, beispielsweise als Zuschlagstoff für Baustoffe, Dämmmaterialien oder Verpackungen. Alternativ folgt die vollständige Re-Integration in den EPS-Produktionskreislauf – aus altem Styropor wird neues Styropor.",
      image: image5,
      width: 400,
      height: 200,
    },
    {
      title: "Ergebnis: Nachhaltiges EPS Recycling Hamburg",
      description: "Das Ergebnis: erhebliche Einsparungen an Rohstoffen und CO2-Emissionen. Jede Tonne recyceltes Polystyrol vermeidet den Einsatz von neuem Erdöl und reduziert den ökologischen Fußabdruck. Professionelles EPS Recycling stärkt die regionale Kreislaufwirtschaft und macht unabhängig von unsicheren Lieferketten. Gleichzeitig profitieren Sie als Unternehmen von deutlich niedrigeren Entsorgungskosten im Vergleich zur thermischen Verwertung.",
      image: null,
      width: 0,
      height: 0,
    }
  ];

  return (
    <div className="business-model-second">
      <div className="business-model-second-content">
        <div className="business-model-second-title">
        <Title 
            static="Die Lösung für Ihr Styropor-Entsorgungsproblem"
          />
          <Title 
            animated="StyroR – Styropor Recycling Hamburg"
          />
        </div>
        <p className="business-model-second-slogan">Verschmutzt - Belastet - HBCD-kontaminiert 🡢 So funktioniert unsere Lösung für Sie!</p>
        <p className="business-model-second-description">Sparen Sie Entsorgungskosten bei Styropor Entsorgung & Steigern Sie Ihren Gewinn durch professionelle EPS Verwertung. Unser bewährter Recycling-Prozess besteht aus mehreren aufeinander abgestimmten Schritten, die Ihr Styropor effizient vom sperrigen Abfall in einen wertvollen Sekundärrohstoff umwandeln. Im Folgenden zeigen wir Ihnen, wie die einzelnen Schritte ablaufen und warum sich Styropor Recycling für Ihr Unternehmen lohnt.</p>

        <div className="business-model-second-timeline">
          {steps.map((step, index) => (
            <div key={index} className="business-model-second-step">
              <div className="business-model-second-step-content">
                {step.image && (
                  <div className="business-model-second-step-image">
                    <img
                      src={step.image}
                      alt={`Schritt ${index + 1}: ${step.title} – Styropor Recycling Prozess`}
                      loading="lazy"
                      width={step.width}
                      height={step.height}
                      onClick={() => openModal(step.image!)}
                    />
                  </div>
                )}
                <div className={`business-model-second-step-text ${!step.image ? 'full-width' : ''}`}>
                  <h3 className="business-model-second-step-title">
                    <span className="business-model-second-step-number">{index + 1}</span>
                    {step.title}
                  </h3>
                  <p>{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {modalImage && (
        <Modal src={modalImage} alt="Styropor Recycling Prozess – Detailansicht" onClose={closeModal} />
      )}
    </div>
  );
};

export default BusinessModelSecond;